import { useController } from 'react-hook-form';
import {
  Preview as FormDialogPreview,
  Image,
} from '@shared/views/form-dialog';
import { makeStyles } from '@material-ui/core/styles';
import DownloadIcon from '@shared/icons/DownloadIcon';
import axios from 'axios';

const FULL_HD_RESOLUTION = {
  width: 1920,
  height: 1080,
};

const useStyles = makeStyles((theme) => ({
  image: {
    maxWidth: '100%',
  },
  dialogPreview: {
    width: 'auto',
    margin: '0 auto',
  },
  downloadButton: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    padding: theme.spacing(0.5),
    display: 'flex',
    backgroundColor: '#E2EAF3',
    border: '1px solid #767676',
    borderRadius: '2px',
    width: '36px',
    height: '36px',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '36px',
    cursor: 'pointer',
  },
}));

const Preview = ({
  name,
  supportedFormats,
  control,
  fileName,
}) => {
  const classes = useStyles();

  const {
    field: { onChange, value, ...inputProps },
  } = useController({
    name,
    control,
    rules: { validate: (value) => !!value.blob || 'Required' },
  });

  const handleDownload = () => {
    axios.get(value.blob, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob',
    })
      .then((response) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = `${fileName?.toLowerCase() || 'background'}.png`;
        a.click();
      })
      .catch((err) => {
        console.log('error', err);
      });
  };

  return (
    <FormDialogPreview
      value={ value }
      supportedFormats={ supportedFormats }
      renderFileViewer={ ({ value }) => (
        <>
          <Image
            value={ value }
            alt="Background"
            className={ classes.image }
          />
          <button
            className={ classes.downloadButton }
            type="button"
            onClick={ handleDownload }
          >
            <DownloadIcon />
          </button>
        </>
      ) }
      onChange={ onChange }
      size={ FULL_HD_RESOLUTION }
      squareShape={ false }
      className={ value?.blob ? classes.dialogPreview : null }
      { ...inputProps }
    />
  );
};

export default Preview;
